import {
  GET_TM_ASSIGNED_TASKS,
  GET_SINGLE_TM_ASSIGNED_TASKS,
  CREATE_TM_ASSIGNED_TASKS,
  UPDATE_TM_ASSIGNED_TASKS,
  DELETE_TM_ASSIGNED_TASKS,
} from "@actions/taskManagement/assignedTasks/types";

import {
  AssignedTasksState,
  AssignedTasksStateAction,
} from "@reducers/types/taskManagement/assigned-tasks-state";

export const initialState: AssignedTasksState = {
  isGetLoading: false,
  isGetSingleLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  getSingleError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  getSingleSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
  getSingleData: null,
};

const assignedTasksReducer = (
  state: AssignedTasksState = initialState,
  action: AssignedTasksStateAction,
): AssignedTasksState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_TM_ASSIGNED_TASKS.LOADING:
      return {
        ...state,
        isGetLoading: payload,
        getSuccess: false,
        getError: null,

        getSingleSuccess: false,
        getSingleError: null,

        createSuccess: false,
        createError: null,

        updateSuccess: false,
        updateError: null,

        deleteSuccess: false,
        deleteError: null,
      };

    case GET_TM_ASSIGNED_TASKS.ERROR:
      return {
        ...state,
        getError: payload,
        getData: null,
        isGetLoading: false,
      };

    case GET_TM_ASSIGNED_TASKS.SUCCESS:
      return {
        ...state,
        getError: null,
        getData: payload,
        getSuccess: true,
        isGetLoading: false,
      };

    // single fetch
    case GET_SINGLE_TM_ASSIGNED_TASKS.LOADING:
      return {
        ...state,
        isGetSingleLoading: payload,
        getSingleError: null,
        getSingleData: null,
        getSingleSuccess: false,

        getSuccess: false,
        getError: null,


        createSuccess: false,
        createError: null,

        updateSuccess: false,
        updateError: null,

        deleteSuccess: false,
        deleteError: null,
      };

    case GET_SINGLE_TM_ASSIGNED_TASKS.ERROR:
      return {
        ...state,
        getSingleData: null,
        getSingleError: payload,
        isGetSingleLoading: false,
      };

    case GET_SINGLE_TM_ASSIGNED_TASKS.SUCCESS:
      return {
        ...state,
        getSingleError: null,
        getSingleData: payload,
        getSingleSuccess: true,
        isGetSingleLoading: false,
      };

    // create
    case CREATE_TM_ASSIGNED_TASKS.LOADING:
      return {
        ...state,
        isCreateLoading: payload,
        createSuccess: false,
        createError: null,

        getSuccess: false,
        getError: null,

        getSingleSuccess: false,
        getSingleError: null,

        updateSuccess: false,
        updateError: null,

        deleteSuccess: false,
        deleteError: null,
      };

    case CREATE_TM_ASSIGNED_TASKS.ERROR:
      return {
        ...state,
        createError: payload,
        createSuccess: false,
        isCreateLoading: false,
      };

    case CREATE_TM_ASSIGNED_TASKS.SUCCESS:
      return {
        ...state,
        createError: null,
        createSuccess: true,
        isCreateLoading: false,
      };

    // update
    case UPDATE_TM_ASSIGNED_TASKS.LOADING:
      return {
        ...state,
        isUpdateLoading: payload,
        updateSuccess: false,
        updateError: null,

        getSuccess: false,
        getError: null,

        getSingleSuccess: false,
        getSingleError: null,

        createSuccess: false,
        createError: null,

        deleteSuccess: false,
        deleteError: null,
      };

    case UPDATE_TM_ASSIGNED_TASKS.ERROR:
      return {
        ...state,
        updateError: payload,
        updateSuccess: false,
        isUpdateLoading: false,
      };

    case UPDATE_TM_ASSIGNED_TASKS.SUCCESS:
      return {
        ...state,
        updateError: null,
        updateSuccess: true,
        isUpdateLoading: false,
      };

    // delete
    case DELETE_TM_ASSIGNED_TASKS.LOADING:
      return {
        ...state,
        isDeleteLoading: payload,
        deleteSuccess: false,
        deleteError: null,

        getSuccess: false,
        getError: null,

        getSingleSuccess: false,
        getSingleError: null,

        createSuccess: false,
        createError: null,

        updateSuccess: false,
        updateError: null,
      };

    case DELETE_TM_ASSIGNED_TASKS.ERROR:
      return {
        ...state,
        deleteError: payload,
        deleteSuccess: false,
        isDeleteLoading: false,
      };

    case DELETE_TM_ASSIGNED_TASKS.SUCCESS:
      return {
        ...state,
        deleteError: null,
        isDeleteLoading: false,
        deleteSuccess: true,
      };

    default:
      return state;
  }
};

export default assignedTasksReducer;
